import AddIcon from '@mui/icons-material/Add';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Fullscreen, FullscreenExit } from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';

interface ColumnPrefsToolbarProps {
  onSave: () => void;
  fullScreen: boolean;
  onToggleFullScreen: () => void;
  onScrollToToday: () => void;
  onAddVoyage?: () => void;
  addVoyageDisabled?: boolean;
  addVoyageTooltip?: string;
}

const ColumnPrefsToolbar = ({
  onSave,
  fullScreen,
  onToggleFullScreen,
  onScrollToToday,
  onAddVoyage,
  addVoyageDisabled = false,
  addVoyageTooltip = '',
}: ColumnPrefsToolbarProps) => (
  <GridToolbarContainer>
    <Button
      size='small'
      startIcon={<EventOutlinedIcon />}
      onClick={onScrollToToday}
    >
      Today
    </Button>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <Button variant='text' onClick={onSave} startIcon={<SaveOutlinedIcon />}>
      Save Column Preferences
    </Button>
    {onAddVoyage && (
      <Tooltip title={addVoyageTooltip} arrow>
        <span style={{ marginLeft: 'auto' }}>
          <Button
            variant='text'
            onClick={onAddVoyage}
            disabled={addVoyageDisabled}
            startIcon={<AddIcon />}
          >
            Add Voyage
          </Button>
        </span>
      </Tooltip>
    )}
    <Tooltip title={fullScreen ? 'Exit full screen' : 'Full screen'}>
      <IconButton
        size='small'
        color={fullScreen ? 'primary' : 'default'}
        onClick={onToggleFullScreen}
        sx={onAddVoyage ? undefined : { ml: 'auto' }}
      >
        {fullScreen ? <FullscreenExit /> : <Fullscreen />}
      </IconButton>
    </Tooltip>
  </GridToolbarContainer>
);

export default ColumnPrefsToolbar;
